import styled, { css } from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { Fragment, useRef, useState } from "react";

export default function Card({ title = "", description = "", price = "", imgSrc = "" }) {
  const [isCardOpened, setIsCardOpened] = useState(false);
  // const [cardDimensions, setCardDimensions] = useState({ width: 0, height: 0 });

  const card = useRef(null);
  const [animationEnd, setAnimationEnd] = useState(true);

  return (
    <Fragment>
      <CardLink
        ref={card}
        layout='scale'
        style={{
          zIndex: isCardOpened ? 10 : animationEnd ? 1 : 10,
        }}
        isCardOpened={isCardOpened}
        onClick={() => {
          if (animationEnd) {
            setIsCardOpened(!isCardOpened);

            setAnimationEnd(false);

            setTimeout(() => {
              setAnimationEnd(true);
            }, 300);
          } else {
            setTimeout(() => {
              setIsCardOpened(!isCardOpened);

              setAnimationEnd(false);

              setTimeout(() => {
                setAnimationEnd(true);
              }, 300);
            }, 500);
          }

          // if (!isCardOpened) {
          //   setCardDimensions({
          //     width: card.current.clientWidth,
          //     height: card.current.clientHeight,
          //   });
          // }
        }}
      >
        <CardImage layout='scale' src={imgSrc} />
        <CardHeader layout='position'>{title}</CardHeader>
        <CardSubtitle layout='position'>
          <span dir='ltr'>{"تومان"}</span>
          <span>{" " + parseInt(price).toLocaleString("de-DE")}</span>
        </CardSubtitle>
        <CardTitleBackdrop layout='scale' style={{ height: isCardOpened ? "250px" : "100px" }} />
        <CardDescription layout='scale' style={{ bottom: isCardOpened ? "15px" : "-250px" }}>
          {description}
        </CardDescription>
      </CardLink>
      <AnimatePresence>
        {isCardOpened && (
          <Fragment>
            {/* <div
              style={{
                width: cardDimensions.width,
                height: cardDimensions.height,
              }}
            ></div> */}
            <CardBackground
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsCardOpened(false)}
            />
            <CardBackdrop
              onClick={() => {
                setIsCardOpened(!isCardOpened);
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
          </Fragment>
        )}
      </AnimatePresence>
    </Fragment>
  );
}

const CardLink = styled(motion.div)`
  width: 100%;
  height: 250px;
  position: relative;
  border-radius: 20px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  z-index: 10;
  ${(props) =>
    props.isCardOpened &&
    css`
      width: min(40rem, 95%);
      height: calc(100% - 10rem);
      position: fixed;
      overflow: hidden;
      border-radius: 40px;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      z-index: 10;
      padding: 20px;
    `};
`;

const CardHeader = styled(motion.div)`
  direction: ltr;
  font-size: 20px;
  font-weight: 700;
  margin: none;
  color: #fff;
`;

const CardSubtitle = styled(motion.div)`
  direction: ltr;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
`;

const CardDescription = styled(motion.div)`
  font-weight: 100;
  font-size: 1em;
  color: #ffffff;
  direction: rtl;
  position: absolute;
  width: 200px;
  z-index: -1;
  right: 10px;
  left: 0;
  bottom: 50px;
`;

const CardImage = styled(motion.img)`
  width: auto;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  overflow: hidden;
  position-area: center;
`;

const CardBackground = styled(motion.div)`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 9;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(10, 10, 10, 0.7);
`;

const CardBackdrop = styled(motion.div)`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 9;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
`;

const CardTitleBackdrop = styled(motion.div)`
  height: 250px;
  width: 110%;
  position: absolute;
  z-index: -1;
  right: -10px;
  left: -10px;
  bottom: -10px;
  // backdrop-filter: blur(10px);
  // -webkit-mask: -webkit-gradient(linear, left 45%, left 0%, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
  background: #141414;
  background: linear-gradient(0deg, rgba(20, 20, 20, 1) 0%, rgba(255, 255, 255, 0) 100%);
`;
